import script from "./EpigeneticsIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./EpigeneticsIntro.vue?vue&type=script&setup=true&lang=js"

import "./EpigeneticsIntro.vue?vue&type=style&index=0&id=1d3f2a46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3f2a46"]])

export default __exports__